angular.module('SpidApp')

.factory('AgencySyncService',
        ['$http', 'SyncConfig', 'Chunker', '$q',
function ($http,   SyncConfig,   Chunker,   $q) {
  var nodePushUrl = SyncConfig.Node.getURLFor('/synchro/agencies')
  var nodeAuthorization = SyncConfig.Node.Authorization
  
  var distantUrl = SyncConfig.Distant.getURLFor('/agencies')
  var distantAuthorization = SyncConfig.Distant.Authorization

  var AgencySyncService = {
    Node: {
      pushAll: function (elems) {
        var chunked = Chunker.inConstantSizeChunks(elems, SyncConfig.config.chunkLength)
        var p = $q(function (r) {r()})
        
        var pools = []
        for(var i = 0 ; i < chunked.length ; i++) {
          var data = chunked[i]
          var req = { method: 'POST', url: nodePushUrl, headers: { 'Authorization': nodeAuthorization }, data: data }
          pools.push($http(req))
        }
        
        return p.then(function () {
          return $q.all(pools)
        }).then(function () {
          return {agencies: 'OK'}
        })
      }
    },
    Distant: {
      getAllUnsync: function () {
        var req = { method: 'GET', url: distantUrl, headers: { 'Authorization': distantAuthorization } }
        
        return $http(req).then(function (response) {
          return response.data
        })
      }
    }
  }

  return AgencySyncService
}])